import {Component, model, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AlertService} from "../../../common/alert/alert.service";
import {AlertComponent} from "../../../common/alert/alert.component";
import {PinholeUser, PinholeUserService} from "../services/pinhole.user.service";

@Component({
    selector: 'search',
    templateUrl: './search.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent
    ],
    providers: [AlertService]
})
export class SearchComponent implements OnDestroy  {
    private formBuilder = new FormBuilder().nonNullable
    private query = this.formBuilder.control("")
    private subscriptions: Subscription[] = [];

    isLoading: boolean = false;
    searchForm = new FormGroup({
        query: this.query,
    });

    readonly user = model<PinholeUser | null>(null);

    constructor(private service: PinholeUserService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    search() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.user.set(null);
        this.subscriptions.push(
            this.service
                .findUser(this.query.value)
                .subscribe(value => {
                    this.isLoading = false;
                    if (value != null) {
                        this.user.set(value);
                    } else {
                        this.alertService.showAlert('danger', "Not found");
                    }
                })
        );
    }
}
